import {Form} from '@goproblems/ui';
import {QuestionMarkPopover} from '@components';

type FormFieldProps = {
    name: string;
    label: string;
    value: string | number | undefined;
    type: 'number' | 'select';
    disabled?: boolean;
    step?: number;
    onChange: React.ChangeEventHandler;
    description?: string;
    options?: {label: string; value: string | number}[];
};

export const TournamentFormField = ({
    name,
    label,
    value,
    type,
    disabled,
    step,
    onChange,
    description,
    options,
}: FormFieldProps) => (
    <Form.Group>
        <Form.Label htmlFor={`tournament-${name}`}>
            {label}
            {description && (
                <QuestionMarkPopover title={label} content={description} />
            )}
        </Form.Label>
        {type === 'select' ? (
            <Form.Select
                id={`tournament-${name}`}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}>
                {options?.map(opt => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </Form.Select>
        ) : (
            <Form.Control
                type="number"
                step={step}
                id={`tournament-${name}`}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
            />
        )}
    </Form.Group>
);
